import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["email", "googleBtn", "msBtn"];

  connect() {
    if (!this.hasEmailTarget) return;
    this.enableProviderButtons();
    this.emailTarget.addEventListener("input", this.onEmailInput.bind(this));
    this.emailTarget.addEventListener("blur", this.onEmailBlur.bind(this));
  }

  enableProviderButtons() {
    if (this.hasGoogleBtnTarget) this.googleBtnTarget.disabled = false;
    if (this.hasMsBtnTarget) this.msBtnTarget.disabled = false;
  }

  disableProviderButtons() {
    if (this.hasGoogleBtnTarget) this.googleBtnTarget.disabled = true;
    if (this.hasMsBtnTarget) this.msBtnTarget.disabled = true;
  }

  removeProviderTooltips() {
    if (this.hasGoogleBtnTarget) {
      this.googleBtnTarget.querySelectorAll('.provider-tooltip').forEach(el => el.remove());
    }
    if (this.hasMsBtnTarget) {
      this.msBtnTarget.querySelectorAll('.provider-tooltip').forEach(el => el.remove());
    }
  }

  onEmailInput() {
    this.disableProviderButtons();
    if (this.hasGoogleBtnTarget) this.googleBtnTarget.classList.remove('provider-highlight');
    if (this.hasMsBtnTarget) this.msBtnTarget.classList.remove('provider-highlight');
    this.removeProviderTooltips();
  }

  async onEmailBlur() {
    const email = this.emailTarget.value;
    this.enableProviderButtons();
    this.removeProviderTooltips();
    if (!email) return;
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
    try {
      const response = await fetch('/emails/provider', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-CSRF-Token': csrfToken || ''
        },
        body: JSON.stringify({ email })
      });
      if (!response.ok) return;
      const data = await response.json();
      if (this.hasGoogleBtnTarget) this.googleBtnTarget.classList.remove('provider-highlight');
      if (this.hasMsBtnTarget) this.msBtnTarget.classList.remove('provider-highlight');
      this.removeProviderTooltips();
      const tooltipText = '☆ Easy Sign In';
      if (data.provider === 'google' && this.hasGoogleBtnTarget) {
        this.googleBtnTarget.classList.add('provider-highlight');
        this.appendTooltip(this.googleBtnTarget, tooltipText);
      } else if (data.provider === 'microsoft' && this.hasMsBtnTarget) {
        this.msBtnTarget.classList.add('provider-highlight');
        this.appendTooltip(this.msBtnTarget, tooltipText);
      }
    } catch (e) {
      // fail silently
    }
  }

  appendTooltip(btn, text) {
    const span = document.createElement('span');
    span.className = 'provider-tooltip';
    span.textContent = text;
    btn.appendChild(span);
  }
}
